import { BusinessDevelopmentConsentVariant } from './business-development-consent-variant';
import { MarketingConsentVariant } from './marketing-consent-variant';
import { IConsentVariant } from './consent-variant.model';

const consentVariants: IConsentVariant[] = [
    new MarketingConsentVariant(),
    new BusinessDevelopmentConsentVariant(),
];

const normalizeConsentIdentifier = (identifier: string): string =>
    `${identifier}`.trim().toLowerCase();

const consentVariantMap = new Map<string, IConsentVariant>(
    consentVariants.map((variant) => [
        normalizeConsentIdentifier(variant.identifier),
        variant,
    ])
);

export const getConsentVariantByIdentifier = (
    identifier?: string
): IConsentVariant | undefined => {
    if (!identifier) {
        return undefined;
    }

    return consentVariantMap.get(normalizeConsentIdentifier(identifier));
};
